























































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class NewsItem extends Vue {
  @Prop() item!: any;

  onJump() {
    if (window.udid && this.item.dataType !== 7 && this.item.dataType !== 5) {
      const { id, classId, isVideo } = this.item;
      const option = {
        dt: isVideo ? 9 : 3,
        cid: classId,
        nid: id,
      };
      window.handleMessage(
        JSON.stringify({
          action: 'mJump',
          data: JSON.stringify(option),
        }),
      );
    } else {
      location.href = this.item.targetUrl;
    }
  }
}
